import styled from 'styled-components/macro';

export const WarningWrapperStyled = styled.div`
  ${({ theme: { spacing } = {} }) => `
    min-height: 56px;
    background-color: #f6e31b;
    padding: 0 ${spacing?.(2)};
    display: flex;
    align-items: center;
    & > div {
      margin: ${spacing?.(1)} ${spacing?.(0.5)};
    }
  `};
`;

export const WarningMessageStyled = styled.span`
  ${({ theme: { spacing, typography } = {} }) => `
    ${typography?.(14)}
    padding: ${spacing?.(1)} 0;
  `};
`;
